module.exports = __webpack_public_path__ + "KaTeX_Math-Italic.1b84970c.ttf";